import { z } from "zod";
import {
  createEventSchema as apiEventSchema,
  bookableEventCreateSchemaBase as apiBookableEventSchema,
  nonBookableEventCreateSchemaBase as apiNonBookableEventSchema,
} from "@api/schemas/events";

// Re-export shared schemas for the Admin app
export const eventSchema = apiEventSchema;
export const bookableEventSchema = apiBookableEventSchema;
export const nonBookableEventSchema = apiNonBookableEventSchema;

export type EventFormData = z.infer<typeof eventSchema>;
export type BookableEventFormData = z.infer<typeof bookableEventSchema>;
export type NonBookableEventFormData = z.infer<typeof nonBookableEventSchema>;
